import { createContext, useContext, useEffect, useState } from "react";
import { CognitoUser, AuthenticationDetails } from "amazon-cognito-identity-js";
import UserPool from "./UserPool";

const UserContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const [user, setUser] = useState({});
  const [newPswdRequired, setNewPswdRequired] = useState({});
  const api = "http://localhost:3000";
  const [userEmail, setUserEmail] = useState(localStorage.getItem("userEmail"));

  const signIn = (email, password) => {
    return new Promise((resolve, reject) => {
      const user = new CognitoUser({
        Username: email,
        Pool: UserPool,
      });

      const authDetails = new AuthenticationDetails({
        Username: email,
        Password: password,
      });

      user.authenticateUser(authDetails, {
        onSuccess: (data) => {
          setUser(user);
          const userEmail = email.split("@")[0];
          setUserEmail(userEmail);
          localStorage.setItem("userEmail", userEmail);
          resolve(data);
        },

        onFailure: (err) => {
          reject(err);
        },

        newPasswordRequired: (userAttributes, requiredAttributes) => {
          setNewPswdRequired({
            user: user,
            userAttributes,
            requiredAttributes,
            required: true,
          });
        },
      });
    });
  };

  const newPswd = (newPassword, email) => {
    return new Promise((resolve, reject) => {
      newPswdRequired.user.completeNewPasswordChallenge(
        newPassword,
        newPswdRequired.requiredAttributes,
        {
          onSuccess: (data) => {
            setUser(user);
            const userEmail = email.split("@")[0];
            setUserEmail(userEmail);
            localStorage.setItem("userEmail", userEmail);
            resolve(data);
          },
          onFailure: (err) => {
            reject(err);
          },
        }
      );
    });
  };

  const logout = () => {
    if (user) {
      user.signOut();
      setUser(null);
    } else {
      console.log("No user to sign out");
    }
  };

  const resetPassword = (email) => {
    return new Promise((resolve, reject) => {
      const user = new CognitoUser({
        Username: email,
        Pool: UserPool,
      });

      user.forgotPassword({
        onSuccess: function (data) {
          // Successfully initiated reset password request
          console.log("CodeDeliveryData from forgotPassword: ", data);
          resolve(data);
        },
        onFailure: function (err) {
          reject(err);
        },
        //Optional automatic callback
        inputVerificationCode: function (data) {
          var verificationCode = prompt(
            "Ingresa el código de verificación de tu correo electrónico ",
            ""
          );
          var newPassword = prompt("Ingresa tu nueva contraseña: ", "");
          user.confirmPassword(verificationCode, newPassword, {
            onSuccess: function () {
              alert("Se restauró la contraseña correctamente!");
              resolve("Password confirmed!");
            },
            onFailure: function (err) {
              console.error(err);
              reject(err);
            },
          });
        },
      });
    });
  };

  useEffect(() => {
    const user = UserPool.getCurrentUser();
    if (user) {
      user.getSession((err, session) => {
        if (err) {
          console.error(err);
        } else {
          setUser(user);
        }
      });
    } else {
      setUser(null);
    }
  }, []);

  return (
    <UserContext.Provider
      value={{
        user,
        signIn,
        logout,
        resetPassword,
        newPswd,
        api,
        userEmail,
        newPswdRequired,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const UserAuth = () => {
  return useContext(UserContext);
};
